import { AlertTriangle, CheckCircle2, Wrench, XCircle } from "lucide-react";
import Navbar from "@/components/Navbar";

const STATUS_STYLES = {
  operational: { label: "Opérationnel", color: "text-emerald-400", Icon: CheckCircle2 },
  maintenance: { label: "En maintenance", color: "text-amber-400", Icon: Wrench },
  outage: { label: "Panne", color: "text-red-400", Icon: XCircle },
};

export default function MaintenancePage({ siteStatus }) {
  const bots = siteStatus?.bots || [];
  const message = siteStatus?.maintenance_message;

  return (
    <div className="min-h-screen bg-[#0a0a0f] text-white">
      <Navbar />
      <main className="pt-24 pb-16 px-6">
        <div className="max-w-lg mx-auto text-center">
          <AlertTriangle className="w-14 h-14 text-amber-400 mx-auto mb-6" strokeWidth={1.5} />
          <h1 className="text-3xl font-bold mb-3">Site en maintenance</h1>
          <p className="text-white/60 mb-10">
            {message || "Nous effectuons une maintenance pour améliorer VantaPulse. Le site sera de retour très bientôt, merci de votre patience."}
          </p>

          {bots.length > 0 && (
            <div className="rounded-2xl border border-white/10 divide-y divide-white/10 overflow-hidden text-left">
              {bots.map((bot) => {
                const style = STATUS_STYLES[bot.status] || STATUS_STYLES.operational;
                const { Icon } = style;
                return (
                  <div key={bot.id} className="flex items-center justify-between px-5 py-4">
                    <span className="text-white/80">{bot.name}</span>
                    <span className={`flex items-center gap-2 text-sm ${style.color}`}>
                      <Icon className="w-4 h-4" />
                      {style.label}
                    </span>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </main>
    </div>
  );
}
